import React from 'react';
import { translate } from '../../../services/translate';
import FilterRadioList, { FilterListItem } from '../FilterRadioList';

export type AttachmentType = 'images' | 'videos' | 'documents' | 'others';

interface Props {
    value: AttachmentType | 'all';
    setValue: React.Dispatch<React.SetStateAction<AttachmentType | 'all'>>;
}

export default function AttachmentTypesList({ value, setValue }: Props) {
    const items: FilterListItem<AttachmentType | 'all'>[] = [
        { label: translate('attachmentImages'), value: 'images' },
        { label: translate('attachmentVideos'), value: 'videos' },
        { label: translate('attachmentDocuments'), value: 'documents' },
        { label: translate('attachmentOthers'), value: 'others' },
    ];

    return <FilterRadioList items={items} value={value} setValue={setValue} clearValue='all' />;
}
